import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import { EMPTY_STRING } from "../../../constants";
import { CloseAdminModalIcon } from "../../../assets";
import RoundedButton from "../../../shared/components/buttons/RoundedButton";

const AgentRejectionModal = ({ show, closeModal, rejectAgent }) => {
  const [comments, setComments] = useState(EMPTY_STRING);

  const onRejectClick = () => {
    rejectAgent(comments);
  };

  useEffect(() => {
    if (!show && comments) setComments(EMPTY_STRING);

    // eslint-disable-next-line
  }, [show]);

  return (
    <Modal
      centered
      show={show}
      onHide={closeModal}
      className="subadmin-modal agent-rejection-modal"
      size="md"
      backdropClassName="reject-modal-backdrop"
    >
      <Modal.Header className="align-items-center justify-content-between subadmin-modal-header pt-4 ps-4">
        <div className="subadmin-modal-heading">Reject Agent</div>
        <img
          src={CloseAdminModalIcon}
          className="pointer"
          onClick={closeModal}
          alt={EMPTY_STRING}
        />
      </Modal.Header>
      <Modal.Body className="subadmin-modal-body">
        <div className="d-flex flex-column justify-content-between">
          <div className="comment-field">
            <label className="py-2">Comments</label>
            <textarea
              className="rounded-4"
              rows={8}
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              maxLength={1000}
            />
          </div>
          <div className="agent-approval-buttons-container d-flex justify-content-center">
            <RoundedButton className="reject-button" onClick={onRejectClick}>
              Reject
            </RoundedButton>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AgentRejectionModal;
